import CookieParser from 'set-cookie-parser';
import map from 'lodash/map';
import nookies from 'nookies';
import reduce from 'lodash/reduce';

import config from '../config';

export function cookieStringToMap(requestCookie = '') {
  const cookie = {};

  try {
    requestCookie.split('; ').forEach((cookiePart) => {
      const key = (cookiePart || '').substring(0, (cookiePart || '').indexOf('='));
      const value = (cookiePart || '').substring((cookiePart || '').indexOf('=') + 1);

      cookie[key] = value;
    });
  } catch (error) {
    throw error;
  }

  return cookie;
}

export function cookieMapToString(cookieMap = {}) {
  return reduce(cookieMap, (result, value, key) => (`${key}=${value}; ${result}`), '');
}

export function setCookie(...args) {
  return nookies.set(...args);
}

export function getCookie(ctx, cookieKey) {
  return nookies.get(ctx)[cookieKey];
}

export function destroyCookie(cookieKey) {
  document.cookie = `${cookieKey}=;path=/;domain=.jobcase.com;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

export function destroyAllCookie() {
  const cookies = document.cookie.split(';');

  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;path=/;domain=.jobcase.com;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
  });
}

export function parseResponseCookies(response) {
  try {
    const cookieHeader = response.headers.get('set-cookie');
    const cookies = CookieParser.splitCookiesString(cookieHeader);

    return map(cookies, (cookie) => {
      let formattedCookie = cookie;

      // Remove secure property on cookie if running locally.
      if (config.environment === 'local') {
        formattedCookie = formattedCookie.replace(' Secure;', '');
        formattedCookie = formattedCookie.replace(' Secure', '');
      }

      return formattedCookie;
    });
  } catch (error) {
    throw error;
  }
}

export const getArrivalKey = () => {
  const cookie = cookieStringToMap(document.cookie);
  return ((config.environment === 'production') ? cookie.jc_arrival : cookie.jc_arrival_staging);
};

export default {
  cookieMapToString,
  cookieStringToMap,
  destroyCookie,
  getCookie,
  parseResponseCookies,
  setCookie,
  getArrivalKey,
  destroyAllCookie,
};
